/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-use-before-define
import React, { FC } from 'react';

export type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark'
  | 'gray'
  | 'link';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  children?: React.ReactNode;
  icon?: string;
  text?: string;
  outlineStyle?: boolean;
  dimStyle?: boolean;
  disabled?: boolean;
  className?: string;
  lgSize?: boolean;
}

const Button: FC<ButtonProps> = ({
  variant = 'primary',
  children,
  icon,
  text,
  outlineStyle,
  dimStyle,
  disabled,
  className,
  lgSize = false,
  ...props
}) => {
  const buttonClassName = `btn ${
    icon && !text && !children ? 'btn-icon' : ''
  } ${dimStyle ? 'btn-dim' : ''} btn${
    outlineStyle ? '-outline' : ''
  }-${variant} ${lgSize ? 'btn-lg' : ''}`;

  return (
    <button
      type="button"
      className={`${buttonClassName} ${className}`}
      disabled={disabled}
      {...props}
    >
      {icon && (
        <em className={`icon ni ni-${icon} ${children ? 'mr-1' : ''}`} />
      )}

      {text ? <span>{text}</span> : null}

      {children}
    </button>
  );
};

export default Button;
